export default "__VITE_ASSET__BkMNeXW4__"